import { useStorage } from '@vueuse/core'

export type Display = 'list' | 'card'

export default function usePinned() {
  // NOTE: this intermediary ref is necessary for handling SSR hydration conflicts
  const display = ref<Display>('list')
  const displayStorage = useStorage<Display>('juss-display', 'list')
  const toggleDisplay = () => (displayStorage.value = displayStorage.value === 'list' ? 'card' : 'list')
  onMounted(() => watch(displayStorage, (val) => (display.value = val), { immediate: true }))

  return { display, toggleDisplay }
}
